var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.7002,
    cy: 34,
    r: 34,
    fill: "url(#paint0_linear_184_3691)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7002 20C29.1794 20 24.7002 24.4274 24.7002 29.8803C24.7002 36.1546 31.3669 46.0977 33.8148 49.532C33.9164 49.677 34.0496 49.7949 34.2034 49.8763C34.3573 49.9576 34.5275 50 34.7002 50C34.8729 50 35.0431 49.9576 35.1969 49.8763C35.3508 49.7949 35.484 49.677 35.5856 49.532C38.0335 46.0991 44.7002 36.1597 44.7002 29.8803C44.7002 24.4274 40.221 20 34.7002 20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7002 35C36.9093 35 38.7002 33.2091 38.7002 31C38.7002 28.7909 36.9093 27 34.7002 27C32.4911 27 30.7002 28.7909 30.7002 31C30.7002 33.2091 32.4911 35 34.7002 35Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_3691",
    x1: -5.0617,
    y1: 77.9556,
    x2: 42.3759,
    y2: 64.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#00D5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA4C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.53761f1d2ae4870ed286a7be52082eb3.svg";
export { ForwardRef as ReactComponent };